export type OrderBillingMessages = {
  //Titles
  billingInformationTitle: string;

  //Labels
  billingAddressLabel: string;
  billingDistrictLabel: string;
  billingCityLabel: string;
  billingZipCodeLabel: string;
};

export const ORDER_BILLING_MESSAGES: OrderBillingMessages = {
  //Titles
  billingInformationTitle: "Informações de Faturamento",

  //Labels
  billingAddressLabel: "Endereço",
  billingDistrictLabel: "Bairro",
  billingCityLabel: "Cidade",
  billingZipCodeLabel: "CEP",
};
